import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import type { SxProps } from '@mui/system';
import type { Theme } from '@mui/material/styles';
import { ReactNode, Suspense } from 'react';

interface IProps {
    fitParent?: boolean;
    withBg?: boolean;
    wrapperSx?: SxProps<Theme>;
}

export const Loading = ({ fitParent, withBg, wrapperSx }: IProps) => {
    return (
        <Box
            sx={{
                ...(fitParent
                    ? { width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }
                    : {
                          display: 'flex',
                          height: '110%',
                          flex: '1 1 auto',
                          position: 'absolute',
                          width: '100%',
                          bottom: '-10%',
                          alignItems: 'center',
                          justifyContent: 'center'
                      }),
                backgroundColor: withBg ? 'rgba(0, 0, 0, 0.1)' : 'transparent',
                ...wrapperSx
            }}
        >
            <CircularProgress role="loading" sx={{ color: 'primary', width: '60px !important', height: '60px !important' }} />
        </Box>
    );
};

export const Error = () => {
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                height: '110%',
                flex: '1 1 auto',
                position: 'absolute',
                width: '100%',
                bottom: '-10%',
                alignItems: 'center',
                justifyContent: 'center'
            }}
        >
            <h2 className="mb-[2.25rem] font-agrandir text-[3.125rem] text-primary sm-max:text-[1.5625rem] xl-max:text-center">
                Something went wrong. Please refresh the page.
            </h2>
        </Box>
    );
};

export const RouteLoading = ({ children }: { children: ReactNode }) => {
    return <Suspense fallback={<Loading />}>{children}</Suspense>;
};

export default RouteLoading;
